export class ApiResultModel {
  status: string;
  message: string;
  data: any;
}

